import React from 'react';
import VoxieLogo from './VoxieLogo';
const Footer = () => {
  return <footer className="bg-gray-900 text-white py-12" data-id="element-49">
      <div className="container mx-auto px-4" data-id="element-50">
        <div className="flex justify-center" data-id="element-51">
          <div className="max-w-md text-center" data-id="element-52">
            <div className="flex items-center justify-center mb-4" data-id="element-53">
              <VoxieLogo className="h-8 w-8 text-[#8de0da] mr-2" data-id="element-54" />
              <span className="text-2xl font-bold" data-id="element-55">VOXIE</span>
            </div>
            <p className="text-gray-400 mb-4" data-id="element-56">
              Offline you can text and call on a local number
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;